export const GET_PRODUCT_SUB_CATEGORY_LIST :string = "/ProductsCategories";
export const GET_PRODUCT_CATEGORY_LIST :string = "/ProductSubCategories";
export const GET_PROVINCE :string = "/Provinces";
export const GET_CITIES :string = "/Cities";
export const REGISTER_USER_CITIES :string = "/userCities";
export const GET_USER_CITIES :string = "/getUserCities";
export const GET_PRODUCT_THUMBNAIL :string = "/getProductThumbnail";
export const GET_PRODUCT_IMAGE :string = "/getProductImage";
export const DELETE_BOOKMARK :string = "/deleteBookmark";
export const PRODUCT_REPORT :string = "/report";
export const GET_USER :string = "/user";
export const VERIFY_IDENTITY :string = "/VerifyIdentity";
export const GET_BANNER :string = "/ActiveBanners";
export const GET_PRODUCT_OWNER :string = "/ProductOwner";
export const UPLOAD_IMAGE :string = "/UploadProductImage";

